import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useRef } from 'react';
import {connect} from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isMobile , isTablet} from 'react-device-detect';
import SongItem from '../../Shared/SongItem/SongItem';
import SelectSongBox from './SelectedSongBox/SelectSongBox';
import randomSongImg from './images/randomSong.png';

const SettingSong = (props) => {
    const sliderRef = useRef();

    useEffect(() => {
        if(isMobile && !isTablet){
            if(props.isDefaultSongSelected)
                sliderRef.current.swiper.slideTo(0);
            else
                sliderRef.current.swiper.slideTo(1);
        }
    },[props.song])

    return (
            <div className='fundial-song-setting'>
                {isMobile && !isTablet &&
                <Swiper
                spaceBetween={15}
                slidesPerView={1.1}
                ref={sliderRef}
                scrollbar={{ draggable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}>
                    <SwiperSlide>
                        <SelectSongBox onSelected={() => {props.onSettings(props.defaultSong)}} audio={props.defaultSong} isSelected={ props.isDefaultSongSelected} title="שיר ברירת מחדל" subTitle="שיר זה מושמע לכל מי שמתקשר אליך" >
                           { props.defaultSong && <SongItem isDisplayPlayer={false} playerSize={87} isDetailsFromLeft={true} audio={props.defaultSong} onClickSong={()=> {}} ></SongItem>}
                        </SelectSongBox>
                    </SwiperSlide>
                    <SwiperSlide>
                        <SelectSongBox onSelected={() => {props.onSettings(null)}} audio={null} isSelected={!props.isDefaultSongSelected} title="נגן רנדומלי" subTitle="כל מי שמתקשר ישמע שיר אחר ברשימה">
                            <Image className="random-song" src={randomSongImg} />
                        </SelectSongBox>
                    </SwiperSlide>
                </Swiper>
                }
                {(!isMobile || isTablet) &&
                <>
                <div className="song-setting-wrapper">
                    <SelectSongBox  onSelected={() => {props.onSettings(props.defaultSong)}} audio={props.defaultSong} isSelected={ props.isDefaultSongSelected} title="שיר ברירת מחדל" subTitle="שיר זה מושמע לכל מי שמתקשר אליך" >
                        { props.defaultSong && <SongItem isDisplayPlayer={false} playerSize={87} isDetailsFromLeft={true} audio={props.defaultSong} onClickSong={()=> {}} ></SongItem>}
                    </SelectSongBox>
                    <SelectSongBox onSelected={() => {props.onSettings(null)}} audio={null} isSelected={!props.isDefaultSongSelected} title="נגן רנדומלי" subTitle="כל מי שמתקשר ישמע שיר אחר ברשימה">
                        <Image className="random-song" src={randomSongImg} />
                    </SelectSongBox>
                </div>
                </>
                }
            </div>
    );
};

const mapStateToProps = (state) => {
    return {
      gallery: state.fundialPage.subscriberGallery,
      defaultSong: state.fundialPage.pages.personalAreaPage.defaultSong,
      isDefaultSongSelected: state.fundialPage.pages.personalAreaPage.isDefaultSongSelected,
    };
  };
  
  const mapDispatchToProps = {
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(SettingSong);
